if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class extends HTMLElement {
    constructor() {
      super();
      this.threshold = parseInt(this.dataset.threshold, 10);
      if (!this.threshold) return;
      this.unsubscribeCart = null;
    }

    handleUpdate = (evt) => {
      const total = evt.cartData?.total_price ?? evt.total_price;
      if (typeof total !== 'undefined') this.render(total);
    };

    connectedCallback() {
      if (!this.threshold) return;

      this.messageContainer = this.querySelector('[data-message-container]');
      this.progressBar = this.querySelector('[data-progress-bar]');
      this.moneyFormat = this.dataset.moneyFormat;
      this.messageTemplate = this.dataset.message || '';
      this.successMessage = this.dataset.successMessage || '';

      const initialTotal = parseInt(this.dataset.cartTotal, 10) || 0;
      this.render(initialTotal);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleUpdate);
       }
    }

    disconnectedCallback() {
      if (typeof this.unsubscribeCart === 'function') {
        this.unsubscribeCart();
        this.unsubscribeCart = null;
      }
    }

    render(total) {
      if (!this.messageContainer) return;

      const remaining = Math.max(0, this.threshold - total);
      const progress = Math.min(100, (total / this.threshold) * 100);

      if (this.progressBar) this.progressBar.style.width = `${progress}%`;

      if (remaining > 0) {
        const formatted = Shopify.formatMoney(Math.ceil(remaining / 100) * 100, this.moneyFormat);
        this.messageContainer.textContent = this.messageTemplate.replace('[amount]', formatted);
      } else {
        this.messageContainer.textContent = this.successMessage;
      }
    }
  });
}